 const DEFAULT_LIFECYCLE = 0

const CONSEQUENCE_OF_FAILURE_OPTIONS = [
  {
    label: 'Insignificant - Minimal or no real harm, tiny financial loss',
    value: 1
  },
  {
    label: 'Minor - Limited damage, minor injury, or short delay',
    value: 2
  },
  {
    label: 'Moderate - Noticeable disruption, medical treatment required, or medium repair costs',
    value: 3
  },
  {
    label: 'Major - Significant operational impact, serious injury, or major financial loss',
    value: 4
  },
  {
    label: 'Catastrophic - Fatality, toxic release, or existential business threat/shutdown',
    value: 5
  }
]

const LIKELIHOOD_OF_FAILURE_TITLE_MAP = {
  1: 'Rare',
  2: 'Unlikely',
  3: 'Possible',
  4: 'Likely',
  5: 'Certain'
}

const LIKELIHOOD_OF_FAILURE_MESSAGE_MAP = {
  1: '- May happen only in exceptional circumstances',
  2: '- Could happen, but not expected under normal conditions',
  3: '- Might happen at some point during operations',
  4: '- Will probably happen often or face recurring exposure',
  5: '- Expected to happen frequently or immediately'
}

const RISK_LABEL_MAP = {
  1: 'Acceptable risk; monitor periodically.',
  2: 'Tolerable risk; maintain or improve controls.',
  3: 'Significant risk; additional controls required before proceeding.',
  4: 'Intolerable risk; stop work immediately until risk is reduced.'
}

const RISK_INDICATOR_CLASS_MAP = {
  1: 'likelihood-consequence-risk__risk-indicator--low',
  2: 'likelihood-consequence-risk__risk-indicator--medium',
  3: 'likelihood-consequence-risk__risk-indicator--high',
  4: 'likelihood-consequence-risk__risk-indicator--extreme'
}

const HELP_TEXT = 
  'Select the correct option that matches the Consequence (of failure) for the asset. This is used to define the risk score for the asset. ' +
  CONSEQUENCE_OF_FAILURE_OPTIONS[0].label + '. ' +
  CONSEQUENCE_OF_FAILURE_OPTIONS[1].label + '. ' +
  CONSEQUENCE_OF_FAILURE_OPTIONS[2].label + '. ' +
  CONSEQUENCE_OF_FAILURE_OPTIONS[3].label + '. ' +
  CONSEQUENCE_OF_FAILURE_OPTIONS[4].label + '.'

export {
  DEFAULT_LIFECYCLE,
  CONSEQUENCE_OF_FAILURE_OPTIONS,
  LIKELIHOOD_OF_FAILURE_TITLE_MAP,
  LIKELIHOOD_OF_FAILURE_MESSAGE_MAP,
  RISK_LABEL_MAP,
  RISK_INDICATOR_CLASS_MAP,
  HELP_TEXT
}
